import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { countProvider } from 'src/app/components/suggestions/suggestions.component';
import { CandidateService } from 'src/app/services/CandidateService';
import { candidateModel } from 'src/app/services/candidateModel';
import { UtilService } from 'src/app/services/util.service';
import { AppSettings } from 'src/app/services/AppSettings';
import { CommonModule } from '@angular/common';
import { CommonSkeletonComponent } from 'src/app/skeleton/common-skeleton/common-skeleton.component';
import { CandidateCardComponent } from 'src/app/components/cards/candidate-card/candidate-card.component';
import { CandidateJobDetailsComponent } from 'src/app/components/candidate-job-details/candidate-job-details.component';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-job-invite-sent',
  standalone: true,
  imports: [
    CommonModule,
    CommonSkeletonComponent,
CandidateCardComponent,
    CandidateJobDetailsComponent,
    InfiniteScrollModule
  ,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './job-invite-sent.component.html',
  styleUrls: ['./job-invite-sent.component.scss']
})
export class JobInviteSentComponent implements OnInit, OnChanges {
  page: any;
  pageName: string = 'job-invite-sent';
  @Input() maxMin: any = {};
  viewType: string = "MIN";
  invitedCandidateList = new BehaviorSubject<any>([]);
  invitedCandidateListAfterKey : string;
  invitedCandidateListStopScroll : boolean = false;
  loadAPIcall:boolean=false;

  URL = "candidates/findCandidatesInvitedByTheUser";
  obj: any = {
    limit: 10,
    searchAfterKey : null,
    userId: localStorage.getItem('userId')
  }
  totalCount : any = 0;
  constructor(private candidateService : CandidateService ,
    private util :UtilService , private provider :countProvider) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.maxMin && changes.maxMin.currentValue) {
      this.maxMin = changes.maxMin.currentValue;
      if (this.maxMin.viewType) {
        this.viewType = this.maxMin.viewType;
      }
    }
  }

  ngOnInit() {
    if (this.maxMin && this.maxMin.viewType) {
      this.viewType = this.maxMin.viewType;
    }
    this.apiCall();
  }

  apiCall() {

    this.loadAPIcall=true;
    this.candidateService.findCandidatesInvitedByTheUser(this.obj).subscribe((response: any) => {
      this.loadAPIcall=false;
      const responseData = response.candidatesInvitations;
      if (response && responseData) {
        const afterKey = response.searchAfterKey;

        if(this.invitedCandidateListAfterKey === afterKey || responseData.length === 0){
          this.invitedCandidateListStopScroll = true;
        }

        const data = responseData.map((item: any) => {
          // Check if candidateEntity exists (wrapper structure)
          if (item.candidateEntity && item.user) {
            // ALWAYS use root level user (candidate owner) for photo in job-invite-sent scenario
            item.candidateEntity.user = item.user;

            // Construct fullname from firstName and lastName if fullname is null
            if (!item.candidateEntity.user.fullname && (item.candidateEntity.user.firstName || item.candidateEntity.user.lastName)) {
              item.candidateEntity.user.fullname = `${item.candidateEntity.user.firstName || ''} ${item.candidateEntity.user.lastName || ''}`.trim();
            }

            // Note: Do NOT add photoUrl prefix here - candidate-job-details template already adds it via downloadurl

            // Merge currentStatus into candidateEntity
            item.candidateEntity.currentStatus = item.currentStatus;
          }

          return item;
        });
        if (this.invitedCandidateListAfterKey !== afterKey) {
          const combinedResponse = [...this.invitedCandidateList.getValue() , ...data];

          this.invitedCandidateList.next(combinedResponse);

        }
        this.invitedCandidateListAfterKey = afterKey;

        if (this.totalCount === 0) {
          this.totalCount = response.total;
          this.provider.setCount(this.totalCount , "JobInviteSentComponent");
        }
      }
      this.util.stopLoader();
    }, err=>{
      this.util.stopLoader();
    });
  }

  pagecount(event) {
    this.page = event;
    this.obj.pageNumber = this.page - 1;
    this.apiCall();
  }


  onScrollDown(){

    if(!this.invitedCandidateListStopScroll&& this.obj.searchAfterKey != this.invitedCandidateListAfterKey){
      this.obj.searchAfterKey = this.invitedCandidateListAfterKey;
      this.apiCall();
    }

  }

}
